/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ApiResult, DeviceScheduleTemplateDto } from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    DeviceScheduleTemplateDtoFromJSON,
    DeviceScheduleTemplateDtoToJSON,
} from "../models/index";

export interface DeviceScheduleTemplateGetRequest {
    deviceScheduleTemplateId: number;
}

export interface DeviceScheduleTemplateListRequest {
    deviceIdentity?: string;
}

export interface DeviceScheduleTemplateSetRequest {
    deviceScheduleTemplateId: number;
    updateDevices?: boolean;
    body?: DeviceScheduleTemplateDto;
}

/**
 *
 */
export class DeviceScheduleHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get device schedule template by id
     */
    async deviceScheduleTemplateGetRaw(
        requestParameters: DeviceScheduleTemplateGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceScheduleTemplateDto>> {
        if (requestParameters["deviceScheduleTemplateId"] == null) {
            throw new runtime.RequiredError(
                "deviceScheduleTemplateId",
                'Required parameter "deviceScheduleTemplateId" was null or undefined when calling deviceScheduleTemplateGet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-schedule-templates/{deviceScheduleTemplateId}`.replace(
                    `{${"deviceScheduleTemplateId"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceScheduleTemplateId"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceScheduleTemplateDtoFromJSON(jsonValue),
        );
    }

    /**
     * Get device schedule template by id
     */
    async deviceScheduleTemplateGet(
        requestParameters: DeviceScheduleTemplateGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceScheduleTemplateDto> {
        const response = await this.deviceScheduleTemplateGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get Active and Inactive device schedule templates
     */
    async deviceScheduleTemplateListRaw(
        requestParameters: DeviceScheduleTemplateListRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceScheduleTemplateDto>>> {
        const queryParameters: any = {};

        if (requestParameters["deviceIdentity"] != null) {
            queryParameters["deviceIdentity"] =
                requestParameters["deviceIdentity"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-schedule-templates`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceScheduleTemplateDtoFromJSON),
        );
    }

    /**
     * Get Active and Inactive device schedule templates
     */
    async deviceScheduleTemplateList(
        requestParameters: DeviceScheduleTemplateListRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceScheduleTemplateDto>> {
        const response = await this.deviceScheduleTemplateListRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Insert/update a template, and set all fields. Schedules are validated only when template.Status==Active. Only Active schedules are visible to be applied by users.
     */
    async deviceScheduleTemplateSetRaw(
        requestParameters: DeviceScheduleTemplateSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceScheduleTemplateId"] == null) {
            throw new runtime.RequiredError(
                "deviceScheduleTemplateId",
                'Required parameter "deviceScheduleTemplateId" was null or undefined when calling deviceScheduleTemplateSet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["updateDevices"] != null) {
            queryParameters["updateDevices"] =
                requestParameters["updateDevices"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-schedule-templates/{deviceScheduleTemplateId}`.replace(
                    `{${"deviceScheduleTemplateId"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceScheduleTemplateId"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceScheduleTemplateDtoToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Insert/update a template, and set all fields. Schedules are validated only when template.Status==Active. Only Active schedules are visible to be applied by users.
     */
    async deviceScheduleTemplateSet(
        requestParameters: DeviceScheduleTemplateSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceScheduleTemplateSetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
